export const userPoolId = process.env.REACT_APP_AWS_USER_POOL_ID || "";
export const region = process.env.REACT_APP_AWS_COGNITO_REGION || "";
export const userPoolClientId =
  process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID_CLIENT ||
  process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID ||
  "";
export const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || "";

export const cognitoAuthConfig = {
  authority: `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`,
  client_id: userPoolClientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: "openid profile email",
  // The metadata coming from the authdomain has an incorrect logout endpoint.
  // AWS suggest using a redirect to the log users out instead of using the auth provider npm.
  // Theoretically it could be fixed by overriding the logout endpoint in the metadata below,
  // but that also requires populating it with the rest of the correct info coming from the auth domain.
  // metadata: {
  //   end_session_endpoint: `https://${cognitoDomain}/logout?client_id=${userPoolClientId}&logout_uri=${encodeURIComponent(
  //     `${window.location.origin}/logout`
  //   )}`,
  // },
};

// Using the following code to logout from cognito also works but does not clean up:
const logoutUri = `${window.location.origin}/logout`;
export const logoutUrl = `https://${cognitoDomain}/logout?client_id=${userPoolClientId}&logout_uri=${encodeURIComponent(
  logoutUri
)}`;

export const cognitoIdentityPoolId =
  process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_CLIENT ||
  process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID ||
  "";
export const runsAppsyncEndpoint =
  process.env.REACT_APP_RUNS_APPSYNC_ENDPOINT || "";
export const runsAppsyncRegion =
  process.env.REACT_APP_RUNS_APPSYNC_REGION || region;

// Amplify configuration for v6
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: userPoolId,
      userPoolClientId: userPoolClientId,
      region: region,
      loginWith: {
        oauth: {
          domain: cognitoDomain,
          scopes: ["openid", "profile", "email"],
          redirectSignIn: [`${window.location.origin}/callback`],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: "code" as const,
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: runsAppsyncEndpoint,
      region: runsAppsyncRegion,
      defaultAuthMode: "userPool" as const,
    },
  },
};
